import Model from './Model';
import version from './../../version';

import game from '../Game/GameInstance';
import Pluralizer from '../Fonts/Pluralizer'

export default class Fps extends Model{

  constructor(data) {

    let width = 450;
    let height = 24;

    super(width, height, data);

    this.clearBeforePositioning = true;

    this.lastStamp = new Date();
    this.frames = 0;


  }

  draw(ctx) {

    let padding = 6;

    let text = [
      'Build date: ' + version + ' (' + game.getVersion() + ')',
      this.data.fps + ' fps',
      new Pluralizer(game.peopleCount, 'person', 'people'),
      this.zoom + 'x',
      game.apiMode ? 'API MODE' : 'DEMO MODE'
    ].join(' | ');

    let fontSize = this.scale(12);
    ctx.font = fontSize + 'px Arial';

    let size = ctx.measureText(text);

    ctx.beginPath();
    ctx.fillStyle = '#ffffff';
    ctx.rect(0, 0, this.scale(this.width + padding * 2), this.scale(this.height));
    ctx.fill();

    ctx.fillStyle = '#000000';
    ctx.fillText(text, 3, this.scale(this.height - 8));

  }

  addFrame()
  {

    const stamp = Date.now();

    this.frames++;

    if (stamp - this.lastStamp > 1000) {

      let fps = Math.round( ( this.frames * 1000 ) / ( stamp - this.lastStamp ) );

      this.lastStamp = stamp;
      this.frames = 0;

      this.set('fps', fps);

    }

  }

}
